import { Logger } from '@deqo/foundation';
import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { BoardData, BoardParticipantData } from '../../api/ApiTypes';
import { ProfileData } from '../../api/endpoints/me';


const errLog = Logger.get('app.errors');

export class MetadataProvider {

    constructor(private api: ApiClient, private boardData: BoardData) {
    }

    public fetchBoardData(): Promise<BoardData> {
        return Promise.resolve(this.boardData);
    }

    public fetchProfileData(): Promise<ProfileData> {
        return this.api.exec(v2.me.info());
    }

    public fetchParticipantData(): Promise<BoardParticipantData[]>;
    public fetchParticipantData(userId: string): Promise<BoardParticipantData | null>;
    public fetchParticipantData(userId?: string): Promise<any> {
        return userId
            ? this.fetchBoardParticipantSingle(userId)
            : this.fetchBoardParticipantList();
    }

    private async fetchBoardParticipantSingle(userId: string) {
        const [result, ok, code] = await this.api.execs(v2.boards.participants.info(this.boardData.id, userId));
        if (ok) return result;
        errLog.warn('MetadataProvider: could not fetch participant', userId, 'due to', code);
        return null;
    }

    private fetchBoardParticipantList() {
        return this.api.exec(v2.boards.participants.list(this.boardData.id));
    }
}
